import { motion } from "framer-motion";
import Image from "next/image";
import logoSports from "@/assets/logos/logoSegmentaçõesTransparente/Colorido/sports.png";

export default function AboutSports() {
  return (
    <motion.div
      className="flex flex-col h-[50vh] justify-evenly items-center shadow-[inset_0px_10px_10px_0px_rgba(0,0,0,0.25)] curiosities
        min-[950px]:flex-col
        min-[950px]:justify-evenly
        min-[950px]:items-center
        min-[950px]:h-[50vh]
        "
    >
      <div className="flex w-[80%] items-center justify-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          exit={{ opacity: 1, top: -10 }}
          transition={{ duration: 1.5 }}
          className="flex w-[50%] h-[45vh] mr-[-240px] items-center"
        >
          <Image
            src={logoSports.src}
            width={300}
            height={302}
            alt="Education Logo"
          />
        </motion.div>
        <div className="w-[2px] h-36 bg-gray-400 mx-6 z-90  opacity-60"></div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          exit={{ opacity: 1, top: 10 }}
          transition={{ duration: 1.5 }}
          className="w-[50%] h-45"
        >
          <p className="text-2xl font-normal text-gray-800">
            O Alertai <span className="text-orange-500">Sports</span> é um
            sistema que permite que você grave os melhores momentos das
            partidas, permitindo que você reviva cada lance.
          </p>
        </motion.div>
        {/* <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          exit={{ opacity: 1, top: 10 }}
          transition={{ duration: 1.5 }}
          className="w-[20%] h-40 mx-10 border-2 border-orange-600 rounded-lg flex flex-col items-center justify-center"
        >
          <span className="text-6xl font-bold text-orange-600">2500</span>
          <p className="text-lg mt-2 font-normal">Alunos cadastrados</p>
        </motion.div> */}
      </div>
    </motion.div>
  );
}
